export class RiskFormModel {

  riskFormUid: number;
  enviromentRisk: string;
  enviromentRiskAction: string;
  enviromentRiskControls: string;

  excavationRisk: string;
  excavationRiskAction: string;
  excavationRiskControls: string;

  undergroundElectricRisk: string;
  undergroundElectricRiskAction: string;
  undergroundElectricRiskControls: string;

  undergroundGasRisk: string;
  undergroundGasRiskAction: string;
  undergroundGasRiskControls: string;

  undergroundWaterRisk: string;
  undergroundWaterRiskAction: string;
  undergroundWaterRiskControls: string;

  undergroundBtRisk: string;
  undergroundBtRiskAction: string;
  undergroundBtRiskControls: string;

  undergroundOtherRisk: string;
  undergroundOtherRiskAction: string;
  undergroundOtherRiskControls: string;

  trafficManagementRisk: string;
  trafficManagementRiskAction: string;
  trafficManagementRiskControls: string;

  manholeRiskElelement: string;
  manholeRiskElelementAction: string;
  manholeRiskElelementControls: string;

  materialsRiskElement: string;
  materialsRiskElementAction: string;
  materialsRiskElementControls: string;

  toolsRiskElement: string;
  toolsRiskElementAction: string;
  toolsRiskElementControls: string;

  reinstatementRiskElement: string;
  reinstatementRiskElementAction: string;
  reinstatementRiskElementControls: string;

  otherRiskElement: string;
  otherRiskElementAction: string;
  otherRiskElementControls: string;

  constructor() {

  }
}